import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import useUserInfo from "../../routers/useUserInfo";
import ImageBox from "../../components/Image";
import { getUserResumesInfo } from "../../service";
import {ResumeData} from "../types";

function ResumeModify(){

    const userData = useUserInfo()
    const [info,setInfo] = useState<ResumeData>()

    useEffect(() =>{
       if(userData){
           getUserResumesInfo({
               userId:userData.id
           }).then(res => {
               if(res.code === 1){
                   setInfo(res.data)
               }
           })
       }
    },[])

    // console.log(info)

    return <div className='user resume-modify'  style={{height: '100vh'}}>
        <div className="lists">

            <Link to={'/user/info/resume/photo'}>
                <div className="name">
                    <p className='title'>简历照片</p>
                </div>
                <div>
                    <div style={{display: "inline-block", width: '.9rem', margin: '-.1rem .1rem'}}>
                        <ImageBox radius={50} src={info?.photo} height={100}/>
                    </div>
                    <span className="iconfont">&#xe608;</span>
                </div>
            </Link>
            <Link to={'/user/info/resume/skill'}>
                <div className="name">
                    <p className='title'>个人特长</p>
                </div>
                <p>
                    <span className="text" style={{ opacity: .6 }}>编辑</span>
                    <span className="iconfont">&#xe608;</span>
                </p>
            </Link>
            <Link to={'/user/info/education'}>
                <div className="name">
                    <p className='title'>教育经历</p>
                </div>
                <p>
                    <span className="text" style={{ opacity: .6 }}>编辑</span>
                    <span className="iconfont">&#xe608;</span>
                </p>
            </Link>
            <Link to={'/user/info/works'}>
                <div className="name">
                    <p className='title'>工作经历</p>
                </div>
                <p>
                    <span className="text" style={{ opacity: .6 }}>编辑</span>
                    <span className="iconfont">&#xe608;</span>
                </p>
            </Link>

            <div className="space"/>

        </div>
    </div>
}

export default ResumeModify
